import './Footer.css';

const Footer = ({ success, msg }) => {
  const flashClass = success ? 'success' : 'failure';
  return (
    <footer className="footer fixed-bottom py-3">
      <div className="container-fluid">
        <div className={flashClass}>{msg}</div>
        <div className="row ftr ftr-bg">
          <div className="ml-2 mr-auto">
            <img src="/footer-mdl.png" alt="" width="298" height="25"></img>
          </div>
          <div className="mr-2">
            <img src="/footer-byline.png" alt="" width="338" height="34"></img>
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.defaultProps = {
  success: true,
  msg: 'flash message goes here',
};

export default Footer;
